// -- Profil --
export const API_GET_PROFIL = 'v1/profil/recuperer';
export const CONTEXT_GET_PROFIL = 'CONTEXT_GET_PROFIL';
export const API_GET_CORRIGER_COMPTE_INCOHERENT = 'v1/profil/corriger-compte-incoherent/';
export const CONTEXT_GET_CORRIGER_COMPTE_INCOHERENT = 'CONTEXT_GET_CORRIGER_COMPTE_INCOHERENT';

// -- Feature Flipping --
export const API_GET_FEATURE_FLIPPING = 'v1/feature-flipping';
export const CONTEXT_GET_FEATURE_FLIPPING = 'CONTEXT_GET_FEATURE-FLIPPING';

// -- CREATION COMPTE --
export const API_COMPTE_CREER_MOTIF_URL = 'v1/compte/creer/etape-1/motif';
export const CONTEXT_COMPTE_CREER_MOTIF = 'CONTEXT_COMPTE_CREER_MOTIF';
export const API_COMPTE_CREER_IDENTITE_URL = 'v2/compte/creer/etape-1/identite';
export const CONTEXT_CREER_COMPTE_ETAPE_IDENTITE = 'CONTEXT_CREER_COMPTE_ETAPE_IDENTITE';
export const API_COMPTE_CREER_ADRESSE_PRINCIPALE_URL = 'v2/compte/creer/etape-1/adresse-principale';
export const CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_PRINCIPALE =
    'CONTEXT_CREER_COMPTE_ETAPE_ADRESSE_PRINCIPALE';

export const API_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2_URL =
    'v2/compte/creer/etape-1/identite/enregistrer-piece-identite/{index}';
export const CONTEXT_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2 =
    'CONTEXT_ENREGISTRER_PIECE_IDENTITE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_V2';

export const API_ENREGISTRER_PERMIS_DE_CHASSE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL =
    'v2/compte/creer/etape-1/identite/enregistrer-permis-de-chasse';

export const CONTEXT_ENREGISTRER_PERMIS_DE_CHASSE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE =
    'CONTEXT_ENREGISTRER_PERMIS_DE_CHASSE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE';

export const API_ENREGISTRER_VALIDATION_PERMIS_CHASSER_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL =
    'v2/compte/creer/etape-1/identite/enregistrer-validation-permis-chasser';

export const CONTEXT_ENREGISTRER_VALIDATION_PERMIS_CHASSER_CREER_COMPTE_DETENTEUR_E_1_IDENTITE =
    'CONTEXT_ENREGISTRER_VALIDATION_PERMIS_CHASSER_CREER_COMPTE_DETENTEUR_E_1_IDENTITE';

export const API_ENREGISTRER_VERSO_LICENCE_CREER_COMPTE_DETENTEUR_E_1_IDENTITE_URL =
    'v2/compte/creer/etape-1/identite/enregistrer-verso-licence';

export const CONTEXT_ENREGISTRER_VERSO_LICENCE_TIR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE =
    'CONTEXT_ENREGISTRER_VERSO_LICENCE_TIR_CREER_COMPTE_DETENTEUR_E_1_IDENTITE';
export const CONTEXT_ENREGISTRER_VERSO_LICENCE_SKI_CREER_COMPTE_DETENTEUR_E_1_IDENTITE =
    'CONTEXT_ENREGISTRER_VERSO_LICENCE_SKI_CREER_COMPTE_DETENTEUR_E_1_IDENTITE';
export const CONTEXT_ENREGISTRER_VERSO_LICENCE_BALLTRAP_CREER_COMPTE_DETENTEUR_E_1_IDENTITE =
    'CONTEXT_ENREGISTRER_VERSO_LICENCE_BALLTRAP_CREER_COMPTE_DETENTEUR_E_1_IDENTITE';
export const API_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2_URL =
    'v2/compte/creer/etape-1/adresse-principale/enregistrer-justificatif-domicile/{index}';
export const CONTEXT_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2 =
    'CONTEXT_ENREGISTRER_JUSTIFICATIF_DOMICILE_CREER_COMPTE_USAGER_E_1_ADRESSE_PRINCIPALE_V2';

export const API_ENREGISTRER_CERTIFICAT_MEDICAL_ARS_CREER_COMPTE_DETENTEUR_E_1_ADRESSE_PRINCIPALE_URL =
    'v2/compte/creer/etape-1/adresse-principale/enregistrer-certificat-medical-ars';

export const CONTEXT_ENREGISTRER_CERTIFICAT_MEDICAL_ARS_CREER_COMPTE_DETENTEUR_E_1_ADRESSE_PRINCIPALE =
    'CONTEXT_ENREGISTRER_CERTIFICAT_MEDICAL_ARS_CREER_COMPTE_DETENTEUR_E_1_ADRESSE_PRINCIPALE';

export const API_COMPTE_CREER_ADRESSES_SECONDAIRES_URL =
    'v1/compte/creer/etape-1/adresses-secondaires';
export const CONTEXT_CREER_COMPTE_ETAPE_ADRESSES_SECONDAIRES =
    'CONTEXT_CREER_COMPTE_ETAPE_ADRESSES_SECONDAIRES';

export const API_COMPTE_CREER_ETAPE_VALIDATION_URL = 'v1/compte/creer/etape-1/validation';
export const CONTEXT_CREER_COMPTE_ETAPE_VALIDATION = 'CONTEXT_CREER_COMPTE_ETAPE_VALIDATION';

// -- Création de compte partie 2
export const API_CREER_COMPTE_USAGER_PARTIE_2_VALIDATION_TOKEN =
    'v1/compte/creer/etape-2/validationToken/';
export const API_CREER_COMPTE_USAGER_PARTIE_2_FINALISER = 'v1/compte/creer/etape-2/finaliser';
export const CONTEXT_CREER_COMPTE_USAGER_PARTIE_2_VALIDATION_TOKEN =
    'CONTEXT_CREER_COMPTE_USAGER_PARTIE_2_VALIDATION_TOKEN';
export const CONTEXT_CREER_COMPTE_USAGER_PARTIE_2_FINALISER =
    'CONTEXT_CREER_COMPTE_USAGER_PARTIE_2_FINALISER';
export const API_CREER_COMPTE_USAGER_PARTIE_2_GENERATION_PDF_LOGIN =
    'v1/compte/creer/etape-2/generation-pdf-login/';
export const CONTEXT_CREER_COMPTE_USAGER_PARTIE_2_GENERATION_PDF_LOGIN =
    'CONTEXT_CREER_COMPTE_USAGER_PARTIE_2_GENERATION_PDF_LOGIN';

// -- Récupération de Login --
export const API_RECUPER_LOGIN_DEMANDE = 'v1/compte/recuperer-login/demander-login/{email}';
export const CONTEXT_RECUPER_LOGIN_DEMANDE = 'CONTEXT_RECUPER_LOGIN_DEMANDE';
export const API_RECUPER_LOGIN_VALIDER_TOKEN = 'v1/compte/recuperer-login/validation-token/{token}';
export const CONTEXT_RECUPER_LOGIN_VALIDER_TOKEN = 'CONTEXT_RECUPER_LOGIN_VALIDER_TOKEN';
export const API_RECUPER_LOGIN_REPONSE = 'v1/compte/recuperer-login/reponse';
export const CONTEXT_RECUPER_LOGIN_REPONSE = 'CONTEXT_RECUPER_LOGIN_REPONSE';

// -- REFERENTIEL --
export const API_GET_REFERENTIEL_PAYS = 'v1/referentiel/pays';
export const API_GET_REFERENTIEL_DEPARTEMENTS = 'v1/referentiel/departements';
export const API_GET_REFERENTIEL_QUESTIONS_COMPTE_USAGER = 'v1/referentiel/questions-compte-usager';
export const CONTEXT_GET_REFERENTIEL_QUESTIONS_COMPTE_USAGER =
    'CONTEXT_GET_REFERENTIEL_QUESTIONS_COMPTE_USAGER';
export const CONTEXT_GET_REFERENTIEL_PAYS = 'CONTEXT_GET_REFERENTIEL_PAYS';
export const CONTEXT_GET_REFERENTIEL_DEPARTEMENTS = 'CONTEXT_GET_REFERENTIEL_DEPARTEMENTS';
export const API_GET_REFERENTIEL_STATUTS_ARMES = 'v1/liste-statuts-armes';
export const CONTEXT_GET_REFERENTIEL_STATUTS_ARMES = 'CONTEXT_GET_REFERENTIEL_STATUTS_ARMES';
export const API_GET_REFERENTIEL_TYPE_JUSTIFICATIF_DOMICILE =
    'v1/referentiel/type-justificatif-domicile';
export const CONTEXT_GET_REFERENTIEL_TYPE_JUSTIFICATIF_DOMICILE =
    'CONTEXT_GET_REFERENTIEL_TYPE_JUSTIFICATIF_DOMICILE';
export const CONTEXT_GET_REFERENTIEL_ELEMENTS_ARME = 'CONTEXT_GET_REFERENTIEL_ELEMENTS_ARME';
export const API_GET_REFERENTIEL_ELEMENTS_ARME = 'v1/referentiel/elements-arme';

// -- ARME EN ERREUR -- //
export const API_GET_ARME_POUR_ERREUR_BY_UNIQUID = 'v1/armes/pour-signaler-erreur/';
export const CONTEXT_GET_ARME_POUR_ERREUR_BY_UNIQUID = 'CONTEXT_GET_ARME_POUR_ERREUR_BY_UNIQUID';

export const API_RETIRER_ARME_EN_ERREUR = 'v1/armes/pour-signaler-erreur/retirer';
export const CONTEXT_RETIRER_ARME_EN_ERREUR = 'CONTEXT_RETIRER_ARME_EN_ERREUR';

export const API_MODIFIER_ARME_EN_ERREUR = 'v1/armes/pour-signaler-erreur/modifier';
export const CONTEXT_MODIFIER_ARME_EN_ERREUR = 'CONTEXT_MODIFIER_ARME_EN_ERREUR';

// -- REPRISE DE DONNÉES -- //
// -- RÉCUPÉRER ARME -- //
export const API_GET_REPRISE_DE_DONNEES_ARME_BY_UNIQID = 'v1/reprise-de-donnees/armes/';
export const CONTEXT_GET_REPRISE_DE_DONNEES_ARME_BY_UNIQID =
    'CONTEXT_GET_REPRISE_DE_DONNEES_ARME_BY_UNIQID';
// -- MODIFIER ARME -- //
export const API_MODIFIER_REPRISE_DE_DONNEES_ARME = 'v1/reprise-de-donnees/armes/modifier';
export const CONTEXT_MODIFIER_REPRISE_DE_DONNEES_ARME = 'CONTEXT_MODIFIER_REPRISE_DE_DONNEES_ARME';
// -- RECUPÉRER
export const API_GET_REPRISE_DE_DONNEES_ARME = 'v1/reprise-de-donnees/armes/recuperer';
export const CONTEXT_GET_REPRISE_DE_DONNEES_ARME = 'CONTEXT_GET_REPRISE_DE_DONNEES_ARME';
// -- SUPPRIMER
export const API_DELETE_REPRISE_DE_DONNEES_ARME = 'v1/reprise-de-donnees/armes/supprimer';
export const CONTEXT_DELETE_REPRISE_DE_DONNEES_ARME = 'CONTEXT_DELETE_REPRISE_DE_DONNEES_ARME';

// -- VALIDER ACQUISITION MATERIEL -- //
export const API_POST_VALIDER_ACQUISITION_MATERIEL = 'v1/materiel/valider-acquisition';
export const CONTEXT_POST_VALIDER_ACQUISITION_MATERIEL =
    'CONTEXT_POST_VALIDER_ACQUISITION_MATERIEL';

// -- RECHERCHE --
export const API_GET_RECHERCHE_ARMES = 'v1/armes/liste';
export const CONTEXT_GET_RECHERCHE_ARMES = 'CONTEXT_GET_RECHERCHE_ARMES';

export const API_GET_RECHERCHE_ARMES_QUOTA_MUNITIONS = 'v1/munitions/liste';
export const CONTEXT_GET_RECHERCHE_ARMES_QUOTA_MUNITIONS =
    'CONTEXT_GET_RECHERCHE_ARMES_QUOTA_MUNITIONS';

// -- BAN --
export const API_POST_VERIFIER_BAN = 'v1/base-adresse-nationale';
export const CONTEXT_POST_VERIFIER_BAN = 'CONTEXT_POST_VERIFIER_BAN';

// -- AJOUTER ARME MANQUANTE -- //
export const API_AJOUTER_ARME_MANQUANTE = 'v1/armes/manquante/signaler';
export const CONTEXT_AJOUTER_ARME_MANQUANTE = 'CONTEXT_AJOUTER_ARME_MANQUANTE';

// -- Récupérer arme via GDR
export const API_RECUPERER_ARME_GDR_AVEC_NUMERO_RGA = 'v1/gdr-arme/recherche/';
export const CONTEXT_RECUPERER_ARME_GDR_AVEC_NUMERO_RGA =
    'CONTEXT_RECUPERER_ARME_GDR_AVEC_NUMERO_RGA';

// -- MOT DE PASSE -- //
export const API_CHANGER_MOT_DE_PASSE = 'v1/mon-compte/changer-mot-de-passe/';
export const CONTEXT_API_CHANGER_MOT_DE_PASSE = 'CONTEXT_CHANGER_MOT_DE_PASSE';

// -- QUESTIONS REPONSES SECRETE -- //
export const API_MODIFIER_QUESTIONS_REPONSES = 'v1/mon-compte/modifier-questions-reponses/';
export const CONTEXT_API_MODIFIER_QUESTIONS_REPONSES = 'CONTEXT_MODIFIER_QUESTIONS_REPONSES';

export const API_RECUPERER_QUESTIONS = 'v1/mon-compte/recuperer-questions/';
export const CONTEXT_API_RECUPERER_QUESTIONS = 'CONTEXT_RECUPERER_QUESTIONS';

// -- DECLARATION ARME PERDUE VOLEE -- //
export const API_DECLARATION_ARME_PERDUE_VOLEE_VALIDER_URL =
    '/v1/armes/declaration-perte-ou-vol/valider';
export const CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_VALIDER =
    'CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_VALIDER';

export const API_DECLARATION_ARME_PERDUE_VOLEE_RECUPERER_URL =
    '/v1/armes/declaration-perte-ou-vol/recuperer';
export const CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_RECUPERER =
    'CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_RECUPERER';

// -- INFORMATIONS PERSONNELLES -- //
export const API_RECUPERER_INFORMATIONS_PERSONNELLES = 'v1/mon-compte/gestion/';
export const CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES =
    'CONTEXT_RECUPERER_INFORMATIONS_PERSONNELLES';

export const API_RECUPERER_ADRESSE_PRINCIPALE = 'v1/mon-compte/adresse/principale/recuperation/';
export const CONTEXT_API_RECUPERER_ADRESSE_PRINCIPALE = 'CONTEXT_API_RECUPERER_ADRESSE_PRINCIPALE';

export const API_MODIFIER_ADRESSE_PRINCIPALE = 'v1/mon-compte/adresse/principale/modification';
export const CONTEXT_API_MODIFIER_ADRESSE_PRINCIPALE = 'CONTEXT_API_MODIFIER_ADRESSE_PRINCIPALE';

export const API_RECUPERER_ADRESSE_SECONDAIRE = 'v1/mon-compte/adresse/secondaire/recuperation/';
export const CONTEXT_API_RECUPERER_ADRESSE_SECONDAIRE = 'CONTEXT_API_RECUPERER_ADRESSE_SECONDAIRE';

export const API_MODIFIER_ADRESSE_SECONDAIRE = 'v1/mon-compte/adresse/secondaire/modification';
export const CONTEXT_API_MODIFIER_ADRESSE_SECONDAIRE = 'CONTEXT_API_MODIFIER_ADRESSE_SECONDAIRE';

export const API_AJOUTER_ADRESSE_SECONDAIRE = 'v1/mon-compte/adresse/secondaire/ajout';
export const CONTEXT_API_AJOUTER_ADRESSE_SECONDAIRE = 'CONTEXT_API_AJOUTER_ADRESSE_SECONDAIRE';

export const API_SUPPRIMER_ADRESSE_SECONDAIRE = 'v1/mon-compte/adresse/secondaire/suppression';
export const CONTEXT_API_SUPPRIMER_ADRESSE_SECONDAIRE = 'CONTEXT_API_SUPPRIMER_ADRESSE_SECONDAIRE';

export const CONTEXT_MODIFIER_PERSONNE_PHYSIQUE = 'CONTEXT_MODIFIER_PERSONNE_PHYSIQUE';
export const API_MODIFIER_PERSONNE_PHYSIQUE = 'v1/mon-compte/personne-physique/modifier';

export const API_MODIFIER_INFORMATIONS_COMPTE = 'v1/mon-compte/modifier-informations';
export const CONTEXT_API_MODIFIER_INFORMATIONS_COMPTE = 'CONTEXT_API_MODIFIER_INFORMATIONS_COMPTE';
export const API_AJOUTER_PERSONA = 'v1/mon-compte/ajouter-persona';
export const CONTEXT_API_AJOUTER_PERSONA = 'CONTEXT_API_AJOUTER_PERSONA';

// -- TELECHARGEMENT DE FICHIER -- //
export const API_RECUPERER_FICHIER_TELECHARGEMENT = 'v1/fichier/telechargement/';
export const CONTEXT_API_RECUPERER_FICHIER_TELECHARGEMENT =
    'CONTEXT_API_RECUPERER_FICHIER_TELECHARGEMENT';

// -- IMPRESSION RATELIER ARME ---
export const API_REMONTER_ARMES_IMPRESSION = '/v1/arme/imprimer-ratelier/liste-arme';
export const CONTEXT_REMONTER_ARMES_IMPRESSION = 'CONTEXT_REMONTER_ARMES_IMPRESSION';
export const API_DEMANDER_IMPRESSION_ARMES = '/v1/arme/imprimer-ratelier/demander';
export const CONTEXT_DEMANDER_IMPRESSION_ARMES = 'CONTEXT_DEMANDER_IMPRESSION_ARMES';

// -- NOTIFICATION -- //
export const API_GET_NOMBRE_NOTIFICATIONS = 'v1/notifications/total';
export const CONTEXT_GET_NOMBRE_NOTIFICATIONS = 'CONTEXT_GET_NOMBRE_NOTIFICATIONS';

export const API_GET_NOTIFICATIONS = 'v1/notifications/';
export const CONTEXT_GET_NOTIFICATIONS = 'CONTEXT_GET_NOTIFICATIONS';

export const API_DELETE_NOTIFICATION = 'v1/notifications/';
export const CONTEXT_DELETE_NOTIFICATION = 'CONTEXT_DELETE_NOTIFICATION';

export const API_DELETE_ALL_NOTIFICATIONS = 'v1/notifications';
export const CONTEXT_DELETE_ALL_NOTIFICATIONS = 'CONTEXT_DELETE_ALL_NOTIFICATIONS';

// CONTACTER PREFECTURE
export const API_CONTACTER_PREFECTURE_PUBLIC = 'v1/contacter/prefecture/anonyme';
export const API_CONTACTER_PREFECTURE_PRIVEE = 'v1/contacter/prefecture/utilisateur';
export const API_CONTACTER_PREFECTURE_PRIVEE_MODIFICATION_INFORMATIONS_PERSONNELLES =
    'v1/contacter/prefecture/utilisateur/modification-informations-personnelles';
export const CONTEXT_CONTACTER_PREFECTURE = 'CONTEXT_CONTACTER_PREFECTURE';

// DEMARCHES DECLARATIONS D'ARMES
export const API_GET_DECLARATIONS_ARMES = 'v1/declarations-armes/lister';
export const API_GET_MES_AUTORISATIONS = 'v1/mes-autorisations/lister';
export const API_GET_MES_DEMARCHES_EN_COURS = 'v1/mes-demarches-en-cours/lister';
export const API_VERIFIER_RENOUVELLENT_AUTORISATION =
    'v1/verifier-demande-renouvellement-autorisation-possible';
export const CONTEXT_MES_AUTORISATIONS = 'v1/mes-autorisations/lister';
export const CONTEXT_MES_DEMARCHES_EN_COURS = 'CONTEXT_MES_DEMARCHES_EN_COURS';
export const CONTEXT_GET_DECLARATIONS_ARMES = 'CONTEXT_GET_DECLARATIONS_ARMES';
export const CONTEXT_GET_DECLARATIONS_ARMES_ALL = 'CONTEXT_GET_DECLARATIONS_ARMES_ALL';

export const API_COMPLETER_DEMANDE_PIECES_JOINTES = 'v1/declarations-armes/completer';
export const CONTEXT_COMPLETER_DEMANDE_PIECES_JOINTES = 'CONTEXT_COMPLETER_DEMANDE_PIECES_JOINTES';

export const API_COMPLETER_AJOUT_CERTIFICAT_MEDICAL =
    'v1/declarations-armes/completer/ajout-certificat-medical';
export const CONTEXT_COMPLETER_AJOUT_CERTIFICAT_MEDICAL =
    'CONTEXT_COMPLETER_AJOUT_CERTIFICAT_MEDICAL';

export const API_GET_LISTE_PIECES_MANQUANTES_DECLARATION_ARMES =
    'v1/declarations-armes/lister-pieces-manquantes';
export const CONTEXT_GET_LISTE_PIECES_MANQUANTES_DECLARATION_ARMES =
    'CONTEXT_GET_LISTE_PIECES_MANQUANTES_DECLARATION_ARMES';

// DEROULE ARME RATELIER
export const API_GET_DEROULE_ARME_RATELIER = 'v1/armes/obtenir-deroule/';
export const CONTEXT_DEROULE_ARME_RATELIER = 'CONTEXT_DEROULE_ARME_RATELIER';

// FICHE SITUATION ARME
export const API_GET_FICHE_SITUATION_ARME = 'v1/armes/fiche-situation-arme/';
export const CONTEXT_FICHE_SITUATION_ARME = 'CONTEXT_FICHE_SITUATION_ARME';

// EXTENSION D'ADRESSE
export const API_RECUPERER_ADRESSE_LISTE_EXTENSION = 'v1/adresse/extension/liste';
export const CONTEXT_API_RECUPERER_ADRESSE_LISTE_EXTENSION =
    'CONTEXT_API_RECUPERER_ADRESSE_LISTE_EXTENSION';

export const API_GET_VISUALISER_DOCUMENT_UTILISATEUR = 'v1/document-utilisateur/recuperer/';
export const CONTEXT_GET_VISUALISER_DOCUMENT_UTILISATEUR =
    'CONTEXT_GET_VISUALISER_DOCUMENT_UTILISATEUR';

// -- CEAF -- //
export const API_GET_EDITER_CEAF = 'v1/ceaf/editer';
export const CONTEXT_EDITER_CEAF = 'CONTEXT_EDITER_CEAF';

export const API_POST_CEAF_CREER = 'v1/ceaf/creer';
export const CONTEXT_CEAF_CREER = 'CONTEXT_CEAF_CREER';

export const API_CEAF_GENERATION_PDF = 'v1/ceaf/generation-pdf/';
export const CONTEXT_CEAF_GENERATION_PDF = 'CONTEXT_CEAF_GENERATION_PDF';

export const API_POST_CEAF_RECUPERER_DERNIERE_EDITEE = 'v1/ceaf/recuperer-derniere-editee';
export const CONTEXT_API_CEAF_RECUPERER_DERNIERE_EDITEE =
    'CONTEXT_API_CEAF_RECUPERER_DERNIERE_EDITEE';

export const API_CEAF_VISUALISER = 'v1/ceaf/visualiser/';
export const CONTEXT_API_CEAF_VISUALISER = 'CONTEXT_API_CEAF_RECUPERER';

// SUPPRESSION D'UNE OU PLUSIEURS ARMES
export const API_SUPPRESSION_ARME_RECUPERER_URL = '/v1/armes/demande-suppression-arme/recuperer';
export const CONTEXT_SUPPRESSION_ARME_RECUPERER = 'CONTEXT_SUPPRESSION_ARME_RECUPERER';

export const API_SUPPRESSION_ARME_VALIDER_URL = '/v1/armes/demande-suppression-arme/valider';
export const CONTEXT_SUPPRESSION_ARME_VALIDER = 'CONTEXT_SUPPRESSION_ARME_VALIDER';

// Demande Arme Trouvée
export const API_DEMANDE_ARME_TROUVEE_URL = '/v1/armes/demande-arme-trouvee';
export const CONTEXT_DEMANDE_ARME_TROUVEE = 'CONTEXT_DEMANDE_ARME_TROUVEE';

// Demande Arme Héritée
export const API_DEMANDE_ARME_HERITEE_URL = '/v1/armes/demande-arme-heritee';
export const CONTEXT_DEMANDE_ARME_HERITEE = 'CONTEXT_DEMANDE_ARME_HERITEE';

// Captcha Etat
export const API_CAPTCHA_ETAT_URL = 'v1/captcha-etat/simple-captcha-endpoint';

// Titre de detention
export const API_FORM_TITRE_DETENTION_URL = '/v1/titre-detentions/:type/form';
export const CONTEXT_FORM_TITRE_DETENTION = 'CONTEXT_FORM_TITRE_DETENTION';

export const API_CREER_TITRE_DETENTION_URL = '/v1/titre-detentions/:type';
export const CONTEXT_CREER_TITRE_DETENTION = 'CONTEXT_CREER_TITRE_DETENTION';

export const API_MODIFIER_TITRE_DETENTION_URL = '/v1/titre-detentions/:type/:uuid';
export const API_TRANSITION_TITRE_DETENTION = '/v1/titre-detentions/:type/:uuid/:transition';
export const CONTEXT_MODIFIER_TITRE_DETENTION = 'CONTEXT_MODIFIER_TITRE_DETENTION';

export const API_RENOUVELLEMENT_TITRE_DETENTION =
    '/v1/titre-detentions/renouvellement-autorisation-possible';
export const CONTEXT_RENOUVELLEMENT_TITRE_DETENTION = 'CONTEXT_RENOUVELLEMENT_TITRE_DETENTION';

export const API_GET_PDF_TITRE_DETENTION = 'v1/titre-detentions/:type/generation-pdf/:uuid';
